import PropTypes from 'prop-types';

import { ImageStyleList } from 'src/components/ImageStyleList';
import { GENERATION_IMPROVE_MODE } from 'src/data/generation';

import { InternalSubmenuListItem } from '../InternalSubmenuListItem';

const propTypes = {
  className: PropTypes.string,
  ImageStyleListProps: PropTypes.shape(ImageStyleList.propTypes).isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};

const defaultProps = {
  className: '',
  selected: false,
  disabled: false,
};

export const ChangeImageStyleItem = ({ className, ImageStyleListProps, selected, disabled }) => {
  return (
    <InternalSubmenuListItem
      className={className}
      improveMode={GENERATION_IMPROVE_MODE.changeImageStyle}
      selected={selected}
      disabled={disabled}
    >
      {({ closeMenu }) => (
        <ImageStyleList
          {...ImageStyleListProps}
          onSelect={(item) => {
            closeMenu();
            ImageStyleListProps.onSelect(item);
          }}
        />
      )}
    </InternalSubmenuListItem>
  );
};

ChangeImageStyleItem.displayName = 'ChangeImageStyleItem';
ChangeImageStyleItem.propTypes = propTypes;
ChangeImageStyleItem.defaultProps = defaultProps;
